import { ClariahLink } from "components/ClariahLink";
import { Grid } from "components/Grid";
import { SMALL } from "shared/constants";
import cx from "classnames";
import styles from "./MetaGrid.module.css";

export const MetaGrid = ({ inverted, inline, meta }) => (
  <Grid size={SMALL}>
    {meta.map(({ title, items }) => (
      <Meta
        key={title}
        title={title}
        items={items}
        inverted={inverted}
        inline={inline}
      />
    ))}
  </Grid>
);

const Meta = ({ title, inverted, inline, items }) => (
  <div
    className={cx(styles.meta, {
      [styles.inverted]: inverted,
      [styles.inline]: inline,
    })}
  >
    <div className={styles.metaTitle}>{title}</div>
    <ul className={styles.metaItemsContainer}>
      {items.map(({ href, type, label }) => (
        <li className={styles.metaItem} key={label}>
          {href ? (
            <ClariahLink href={href} type={type} size={SMALL}>
              {label}
            </ClariahLink>
          ) : (
            label
          )}
        </li>
      ))}
    </ul>
  </div>
);
